import styled from 'styled-components';

export const RightContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;
